import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { ClientType } from '../ClientSearch.meta';

export interface Client {
  FirstName: string;
  LastName: string;
  DisplayableConsumerId: string;
  OrganizationName: string;
  ConsumerId: number;
  Type: ClientType;
  OnboardingEndpoint?: string | null;
}

export const searchClients = async (
  term: string,
  type: string | null = null,
): Promise<Client[]> => {
  return authFetch(urlWithParams('/Adviser/Search', { term, type }, { skipNulls: true }));
};

export const useSearchClientsQuery = (term: string, type: string | null = null) => {
  return useQuery(
    queryKeys.searchClients(term, type),

    () => searchClients(term, type),

    {
      enabled: !!term,
    },
  );
};
